var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../ui/Button";
import { Share2Icon } from "@radix-ui/react-icons";
export function ButtonAccessGovPi() {
    function goExternalService(event) {
        var baseUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";
        var url = baseUrl +
            "/app/app-detran-habilitacao/obter-permissao-internacional-para-dirigir-(pid)";
        var newWindow = window.open(url, "_blank");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
    }
    return (_jsxs(Button, __assign({ variant: "tertiary", onClick: goExternalService, className: "self-end w-full" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })));
}
